/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:60521865-6b31-429a-a9ab-a7b6922782df",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_vLQg1g7vg",
    "aws_user_pools_web_client_id": "71776qe08ig4q1b1h0srdh93ij",
    "oauth": {
        "domain": "f0yauinupgk0-prod.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://develop.connected.college/,https://develop.connected.college,connected://,https://www.master.connected.college,https://master.connected.college,https://master.connected.college/,https://www.master.connected.college/",
        "redirectSignOut": "https://develop.connected.college/,https://develop.connected.college,connected://,https://www.master.connected.college,https://master.connected.college,https://master.connected.college/,https://www.master.connected.college/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "FACEBOOK",
        "GOOGLE",
        "APPLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
